import { useMutation } from '@tanstack/react-query';
import { resendOtp, type ResendOtpPayload } from '@/api/auth.api';

/**
 * Resend-verification-code mutation (MYN-46 A2). The backend is deliberately
 * non-enumerating, so success here only means "request accepted" - the UI shows
 * a neutral confirmation regardless of whether the address exists.
 */
export function useResendOtp() {
  return useMutation({ mutationFn: (payload: ResendOtpPayload) => resendOtp(payload) });
}
